import * as actionType from "../types/ActionTypes";
import axios from "../../shared/axios";
import Swal from "sweetalert2";
import { baseUrl } from "../../shared/baseURL";

export const payuPaymentSetData = (payuPayment) => {
  return {
    type: actionType.PAYU_PAYMENT_SET_DATA,
    payuPayment: payuPayment,
  };
};

export const payuPaymentFailData = (error) => {
  return {
    type: actionType.PAYU_PAYMENT_FAIL_DATA,
    error: error,
  };
};

export const payuPaymentLoading = () => {
  return {
    type: actionType.PAYU_PAYMENT_LOADING,
  };
};

export const payuPaymentGetData = () => {
  return (dispatch) => {
    dispatch(payuPaymentLoading());
    axios
      .get(baseUrl + "/payu-payment", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(payuPaymentSetData(res.data));
      })
      .catch((error) => dispatch(payuPaymentFailData(error)));
  };
};

export const deletePayuPaymentFail = (error) => {
  return {
    type: actionType.DELETE_PAYU_PAYMENT_FAIL,
    error: error,
  };
};

export const deletePayuPayment = (id, data) => {
  return (dispatch) => {
    if (id) {
      axios
        .delete(baseUrl + `/payu-payment/${data.id}`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data?.token,
          },
        })
        .then(() => {
          Swal.fire("Deleted!", "Your file has been deleted.", "success").then(
            () => {
              dispatch(payuPaymentGetData(data));
            }
          );
        })
        .catch((error) => dispatch(deletePayuPaymentFail()));
    }
  };
};

export const postPayuPaymentDataStart = () => {
  return {
    type: actionType.POST_PAYU_PAYMENT_DATA_START,
  };
};

export const postPayuPaymentDataFail = (error) => {
  return {
    type: actionType.POST_PAYU_PAYMENT_DATA_FAIL,
    error: error,
  };
};

export const postPayuPaymentDataSuccess = (success) => {
  return {
    type: actionType.POST_PAYU_PAYMENT_DATA_SUCCESS,
    success: success,
  };
};

export const payuPaymentPostLoading = () => {
  return {
    type: actionType.PAYU_PAYMENT_POST_LOADING,
  };
};

export const postPayuPaymentData = (payuPayment, setSubmitting, resetForm) => {
  return (dispatch) => {
    dispatch(postPayuPaymentDataStart());
    dispatch(payuPaymentPostLoading());
    axios
      .post(baseUrl + "/payu-payment", payuPayment, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(postPayuPaymentDataSuccess(res.data));
        // dispatch(payuPaymentGetData());
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Registered !",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (setSubmitting) {
            setSubmitting(false);
          }
          resetForm();
          // window.open(
          //   "https://ajivasanmusicacademy.com/ajivasan-backend/public/pay-u-money-view",
          //   "_blank"
          // );
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(postPayuPaymentDataFail(error));
      });
  };
};

export const updatePayuPaymentDataStart = () => {
  return {
    type: actionType.UPDATE_PAYU_PAYMENT_DATA_START,
  };
};

export const payuPaymentUpdateLoading = () => {
  return {
    type: actionType.PAYU_PAYMENT_UPDATE_LOADING,
  };
};

export const updatePayuPaymentDataFail = (error) => {
  return {
    type: actionType.UPDATE_PAYU_PAYMENT_DATA_FAIL,
    error: error,
  };
};

export const updatePayuPaymentDataSuccess = (success) => {
  return {
    type: actionType.UPDATE_PAYU_PAYMENT_DATA_SUCCESS,
    success: success,
  };
};

export const updatePayuPaymentData = (
  data,
  payuPayment,
  toggle,
  setSubmitting
) => {
  return (dispatch) => {
    dispatch(updatePayuPaymentDataStart());
    dispatch(payuPaymentUpdateLoading());

    axios
      .put(baseUrl + `/payu-payment/${data.id}`, payuPayment, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(updatePayuPaymentDataSuccess(res.data));
        dispatch(payuPaymentGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Updated !",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(updatePayuPaymentDataFail(error));
      });
  };
};
